export const SITE_NAME = 'VEGAAHI IT PVT LTD';
export const SITE_SHORT_NAME = 'VEGAAHI';
export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) ?? 'https://www.vegaahi.com';
export const SITE_TAGLINE = 'Engineering enterprise-grade digital transformation.';
export const SITE_DESCRIPTION =
  'VEGAAHI IT PVT LTD delivers enterprise software, cloud, AI, and digital transformation solutions for growing businesses worldwide.';

export const CONTACT_EMAIL = 'vegaahiit@gmail.com';
export const SALES_EMAIL = 'vegaahiit@gmail.com';
export const CONTACT_PHONE = '+91 94945 29988';
export const OFFICE_ADDRESS =
  '5-11-118, 3rd Floor, Beside Lane Green Square Plaza, Hanamkonda, Telangana 506001, India';

export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/company/vegaahi',
  twitter: 'https://twitter.com/vegaahi',
  github: 'https://github.com/vegaahi',
  youtube: 'https://youtube.com/@vegaahi',
} as const;

export interface NavLink {
  label: string;
  href: string;
}

export const PRIMARY_NAV: NavLink[] = [
  { label: 'Services', href: '/services' },
  { label: 'Portfolio', href: '/portfolio' },
  { label: 'About', href: '/about' },
  { label: 'Careers', href: '/careers' },
  { label: 'Blog', href: '/blog' },
];

export const FOOTER_LEGAL_LINKS: NavLink[] = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
];

export const COMPANY_STATS = [
  { label: 'Years of experience', value: 12, suffix: '+' },
  { label: 'Projects delivered', value: 240, suffix: '+' },
  { label: 'Enterprise clients', value: 60, suffix: '+' },
  { label: 'Countries served', value: 15, suffix: '+' },
] as const;
